import { Entity } from '.'
import isNotNil from '../../ldsh/isNotNil'

export default function isEntityOutOfMoves(entity: Entity): boolean {
  const { mobility } = entity
  return isNotNil(mobility) && mobility <= 0
}
